<aside
  class="sidebar mtm-glass"
  [class.sidebar--collapsed]="collapsed()"
  [attr.aria-label]="'SIDEBAR.NAV_LABEL' | translate"
>
  <!-- Header: logo + collapse toggle -->
  <div class="sidebar__header">
    <a routerLink="/tenants" class="sidebar__brand" [attr.aria-label]="'MTM Platform admin'">
      <span class="sidebar__logo">
        <img src="/assets/MTM_logo.svg" alt="" />
      </span>
      @if (!collapsed()) {
        <span class="sidebar__brand-text">
          <span class="sidebar__brand-name">MTM</span>
          <span class="sidebar__eyebrow">{{ 'SIDEBAR.PLATFORM_ADMIN' | translate }}</span>
        </span>
      }
    </a>
    <button
      type="button"
      class="sidebar__icon-btn sidebar__toggle"
      [attr.aria-expanded]="!collapsed()"
      [attr.aria-label]="
        (shell.mobileNavOpen()
          ? 'SIDEBAR.CLOSE_MENU'
          : collapsed()
            ? 'SIDEBAR.EXPAND'
            : 'SIDEBAR.COLLAPSE'
        ) | translate
      "
      (click)="onToggleSidebar()"
    >
      <mtm-icon [name]="shell.mobileNavOpen() ? 'close' : 'panel'" [size]="16" />
    </button>
  </div>

  <!-- Context card: tenant + subscription, the active scope at a glance -->
  @if (collapsed()) {
    <button
      type="button"
      class="sidebar__context-mini"
      [attr.aria-label]="'SIDEBAR.CONTEXT' | translate"
      [attr.data-tip]="
        (context.selectedTenant()?.tenantName ?? ('SIDEBAR.SELECT_TENANT' | translate)) +
        ' · ' +
        (context.selectedSubscription()?.subscriptionName ??
          ('SIDEBAR.SELECT_SUBSCRIPTION' | translate))
      "
      (click)="expand()"
    >
      <span class="sidebar__context-initial">{{
        (context.selectedTenant()?.tenantName ?? '?').charAt(0).toUpperCase()
      }}</span>
    </button>
  } @else {
    <section class="sidebar__context" [attr.aria-label]="'SIDEBAR.CONTEXT' | translate">
      <mtm-tenant-selector />
      <div class="sidebar__context-divider"></div>
      <mtm-subscription-selector />
    </section>
  }

  <nav class="sidebar__nav beauty-scroll">
    <span class="sidebar__section">{{ 'SIDEBAR.SECTION_PLATFORM' | translate }}</span>
    @for (item of platformNav; track item.path) {
      <a
        [routerLink]="'/' + item.path"
        routerLinkActive="sidebar__link--active"
        class="sidebar__link"
        [attr.data-tip]="collapsed() ? (item.labelKey | translate) : null"
        [attr.aria-label]="collapsed() ? (item.labelKey | translate) : null"
      >
        <mtm-icon [name]="item.icon" [size]="16" />
        @if (!collapsed()) {
          <span>{{ item.labelKey | translate }}</span>
        }
      </a>
    }

    <span class="sidebar__section sidebar__section--spaced">{{
      'SIDEBAR.SECTION_AI' | translate
    }}</span>
    @if (consoleBase(); as base) {
      @for (item of consoleNav; track item.path) {
        <a
          [routerLink]="[...base, item.path]"
          routerLinkActive="sidebar__link--active"
          class="sidebar__link"
          [attr.data-tip]="collapsed() ? (item.labelKey | translate) : null"
          [attr.aria-label]="collapsed() ? (item.labelKey | translate) : null"
        >
          <mtm-icon [name]="item.icon" [size]="16" />
          @if (!collapsed()) {
            <span>{{ item.labelKey | translate }}</span>
          }
        </a>
      }
    } @else {
      @if (collapsed()) {
        <span
          class="sidebar__link sidebar__link--disabled"
          [attr.data-tip]="'SIDEBAR.SELECT_SUBSCRIPTION' | translate"
        >
          <mtm-icon name="bot" [size]="16" />
        </span>
      } @else {
        <span class="sidebar__hint">{{ 'SIDEBAR.SELECT_SUBSCRIPTION' | translate }}</span>
      }
    }
  </nav>

  <!-- Footer: help + logout -->
  <div class="sidebar__footer">
    <a
      routerLink="/help"
      routerLinkActive="sidebar__link--active"
      class="sidebar__link"
      [attr.data-tip]="collapsed() ? ('SIDEBAR.NAV.HELP' | translate) : null"
      [attr.aria-label]="collapsed() ? ('SIDEBAR.NAV.HELP' | translate) : null"
    >
      <mtm-icon name="help" [size]="16" />
      @if (!collapsed()) {
        <span>{{ 'SIDEBAR.NAV.HELP' | translate }}</span>
      }
    </a>
    <button
      type="button"
      class="sidebar__link"
      [attr.data-tip]="collapsed() ? ('SIDEBAR.NAV.LOGOUT' | translate) : null"
      [attr.aria-label]="collapsed() ? ('SIDEBAR.NAV.LOGOUT' | translate) : null"
      (click)="onLogout()"
    >
      <mtm-icon name="logout" [size]="16" />
      @if (!collapsed()) {
        <span>{{ 'SIDEBAR.NAV.LOGOUT' | translate }}</span>
      }
    </button>
  </div>
</aside>
